import React from 'react'
import PropTypes from 'prop-types'
import ProductSelection from '../../../components/ProductSelectionsContainer/ProductSelection'
import texts from '../../../common/texts.json'
import { sliderProductsConfig } from './utils'

const ProductSlider = ({ products, isMobile, origin }) => (
  <section>
    {products.length > 0
      ? (<h2 className="void-plp__suggested-product">{texts.VOID_PLP.RELATED_PRODUCT}</h2>)
      : (<h2>{texts.VOID_PLP.CATEGORY_TEXT}</h2>)}
    {products.length > 0 && (
    <ProductSelection
      origin={origin}
      id="void-plp__suggested-product__list"
      products={products}
      isMobile={isMobile}
      productSelectionsAsCarousel
      customSettingsTopProducts={sliderProductsConfig}
    />
    )}
  </section>
)

ProductSlider.defaultProps = {
  products: [],
  isMobile: false,
  origin: '',
}
ProductSlider.propTypes = {
  products: PropTypes.array,
  isMobile: PropTypes.bool,
  origin: PropTypes.string,
}

export default ProductSlider
